import type { DronePoint } from "@endclock/shared";

export interface DroneTransform { position: DronePoint; velocity: DronePoint; yaw: number }
export interface InterpolatedDroneTransform { x: number; y: number; z: number; yaw: number }
export const DRONE_INTERPOLATION_DELAY_MS = 100;
export const DRONE_EXTRAPOLATION_LIMIT_MS = 250;

/** Writes into reusable render storage. Decisions, battery and task clocks stay authoritative. */
export function interpolateDroneTransform(
  previous: DroneTransform, current: DroneTransform, previousAt: number, currentAt: number,
  serverNow: number, output: InterpolatedDroneTransform,
): void {
  const renderAt = serverNow - DRONE_INTERPOLATION_DELAY_MS;
  const interval = currentAt - previousAt;
  const alpha = interval > 0 ? Math.max(0, Math.min(1, (renderAt - previousAt) / interval)) : 1;
  const extra = Math.min(DRONE_EXTRAPOLATION_LIMIT_MS, Math.max(0, renderAt - currentAt)) / 1_000;
  output.x = previous.position.x + (current.position.x - previous.position.x) * alpha + current.velocity.x * extra;
  output.y = previous.position.y + (current.position.y - previous.position.y) * alpha + current.velocity.y * extra;
  output.z = previous.position.z + (current.position.z - previous.position.z) * alpha + current.velocity.z * extra;
  const yawDelta = Math.atan2(Math.sin(current.yaw - previous.yaw), Math.cos(current.yaw - previous.yaw));
  output.yaw = previous.yaw + yawDelta * alpha;
}
